(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alliance-science-links"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
  const link = event.target.closest?.('.sc-menu-links a');
  const drawer = link?.closest('header-drawer');
  if (drawer && typeof drawer.close === 'function') drawer.close();
});
  } catch(e) { console.error(e); }
})();

})();
